// extracted by mini-css-extract-plugin
module.exports = {"play":"BigPlayButton_play__xytKf"};